import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './pay.scss';

import React, { useState, useEffect } from 'react';
import { components, services } from 'common';
const { Toast } = services;
const { If, Dialog, DialogBody, PreImg } = components;
import { $document, classSet } from '@umu/umu-dom';
import { formatNumToMoney } from '@umu/umu-util';
import { pay, takeOrder, watchPayResult, IOrderData, ITakeOrderOutput } from '../../services/@payService/payService';
import { getCurrencySymbol } from '../../@utils/umuUtil';

interface IProps {
    orderData: IOrderData;
    payDesc?: string;
    payChannel: string[];
    paySuccess: () => void;
    payFail: () => void;
    onClose: () => void;
}

export default function Pay(props: IProps) {
    useEffect(() => {
        return () => {
            watchPayResult.cancel();
        };
    }, []);

    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState('');

    const onTakeOrder = (channel: string) => {
        if (isProcessing) {
            return;
        }

        Toast.show({
            message: lang('订单生成中...'),
            duration: 99999999, // 一直显示，直到支付完成主动关闭
        });

        setIsProcessing(true);
        setSelectedChannel(channel);
        const orderData = props.orderData;
        orderData.pay_channel = channel;
        takeOrder(orderData, takeOrderCallBack);
    };

    const reTakeOrder = () => {
        if (!selectedChannel) {
            return;
        }
        const orderData = props.orderData;
        orderData.pay_channel = selectedChannel;
        takeOrder(orderData, takeOrderCallBack);
    };

    const onSuccess = () => {
        setIsWxPubQrShow(false);
        props.paySuccess();
        props.onClose();
    };

    const onFail = () => {
        props.payFail();
        if (selectedChannel === 'wx_pub_qr') {
            setIsWxPubQrRetryShow(true);
        }
    };

    const takeOrderCallBack = (result: ITakeOrderOutput) => {
        setIsProcessing(false);
        Toast.hide();

        if (result.errno !== 0 && result.error && result.error !== 'success') {
            Toast.show(result.error);
            return;
        }

        const data = result.data;

        // 有可能已经支付完成了，再次点击
        if (data.pay_status === 'success') {
            onSuccess();
            return;
        }
        if (data.pay_qr) {
            setWxPubQrUrl(data.pay_qr);
            setIsWxPubQrShow(true);
            setIsPayShow(false);
        }

        // TODO 如果是 paypal 支付就跳转到 paypal 支付页面
        if (selectedChannel === 'paypal') {
            $document.body.innerHTML += data.paypal_html!;
        } else {
            pay({
                chargeData: data.charge,
                success: onSuccess,
                fail: onFail,
            });
        }
    };

    const [isWxPubQrShow, setIsWxPubQrShow] = useState(false);
    const [wxPubQrUrl, setWxPubQrUrl] = useState('');
    const [isWxPubQrRetryShow, setIsWxPubQrRetryShow] = useState(false);
    const renderWxPubQr = () => {
        if (!isWxPubQrShow) {
            return null;
        }
        return (
            <Dialog
                show={true}
                hasMask={true}
                className="pay-qr-dialog"
                canClose={true}
                close={() => props.onClose()}
                width="300px"
            >
                <DialogBody>
                    <div className="pay-qr-code">
                        <If condition={isWxPubQrRetryShow}>
                            <div className="re-try">
                                <div className="opt">
                                    {lang('二维码已过期，')}
                                    <a href="javascript:" onClick={reTakeOrder} className="btn">
                                        {lang('点击这里')}
                                    </a>
                                    {lang('获取新的二维码。')}
                                </div>
                            </div>
                        </If>
                        <div className="img">
                            <PreImg>
                                <img src={wxPubQrUrl} alt="" />
                            </PreImg>
                        </div>
                    </div>
                    <div className="pay-qr-code-desc">
                        <p>{lang('请使用微信扫一扫')}</p>
                        <p>{lang('扫描二维码支付')}</p>
                    </div>
                </DialogBody>
            </Dialog>
        );
    };

    const [isPayShow, setIsPayShow] = useState(true);
    const renderPay = () => {
        if (!isPayShow) {
            return null;
        }
        const orderData = props.orderData;
        const channelList = props.payChannel;
        const channelMap = {
            alipay_wap: lang('支付宝支付'),
            wx_pub: lang('微信支付'),
            wx_pub_qr: lang('微信支付'),
            paypal: lang('PayPal'),
        };
        const amount = formatNumToMoney(orderData.amount / 100);
        const currencySymbol = getCurrencySymbol();
        return (
            <Dialog
                show={true}
                hasMask={true}
                className="pay-channel-dialog"
                canClose={true}
                close={() => props.onClose()}
                width="300px"
            >
                <DialogBody>
                    <div className="channel-header">
                        <div className="pay-title">{lang('请选择支付方式')}</div>
                        <div className="pay-desc">
                            {props.payDesc}{' '}
                            <em>
                                {currencySymbol} {amount}
                            </em>
                        </div>
                    </div>
                    <div className="pay-channels">
                        {channelList.map((channelItem, index) => {
                            const classNameMap = {
                                'pay-channel': true,
                                [channelItem]: true,
                            };
                            const channelItemClassName = classSet(classNameMap);

                            return (
                                <div
                                    key={index}
                                    className={channelItemClassName}
                                    onClick={() => onTakeOrder(channelItem)}
                                >
                                    {channelMap[channelItem as keyof typeof channelMap]}
                                </div>
                            );
                        })}
                    </div>
                </DialogBody>
            </Dialog>
        );
    };

    const render = () => {
        return (
            <>
                {renderPay()}
                {renderWxPubQr()}
            </>
        );
    };
    return render();
}
